import React from 'react';
// import ProgressBar from "@ramonak/react-progress-bar";

const Skills = () => {
    return (
        <div className='pt-28 overflow-x-hidden' id='skills'>
            <div className="container mx-auto pb-28">
                <div className='text-center space-y-8'>
                    <h4 data-aos="fade-right" className='uppercase text-lg text-white font-thin tracking-[6px]'>Skills</h4>
                    <h2 data-aos="fade-left" className='text-4xl md:text-6xl color-font'>My Skills <br /> in this Amazing platform.</h2>
                </div>

                <div className="grid grid-cols-4 gap-12 pt-20">

                    <div data-aos="flip-left" data-aos-easing="ease-out-cubic" className='text-center col-span-4 sm:col-span-2 lg:col-span-1 space-y-10'>
                        {/* <h4 className='text-2xl text-white'>Javascript</h4> */}
                        {/* <div className="radial-progress" style={{ "--value": "70", "--size": "12rem", "--thickness": "2px" }}>70%</div> */}
                        <div className="radial-progress color-font" style={{ "--value": "85", "--size": "12rem", "--thickness": "2px" }}>
                            <span className='text-2xl'>Javascript</span>

                        </div>
                        {/* <ProgressBar
                            // className='bg-primary'
                            bgColor="#DCA54C"
                            // customLabel="Javascript"
                            completed={60}
                            // className=""
                            // barContainerClassName="bg-slate-300 h-2"
                            // completedClassName="bg-neutral-content"
                            // labelClassName="text-sm"
                        /> */}
                    </div>
                    <div data-aos="flip-right" data-aos-easing="ease-out-cubic" className='text-center col-span-4 sm:col-span-2 lg:col-span-1 space-y-10'>
                        <div className="radial-progress color-font" style={{ "--value": "80", "--size": "12rem", "--thickness": "2px" }}>
                            <span className='text-2xl'>React</span>
                        </div>
                    </div>
                    <div data-aos="flip-left" data-aos-easing="ease-out-cubic" className='text-center col-span-4 sm:col-span-2 lg:col-span-1 space-y-10'>
                        <div className="radial-progress color-font" style={{ "--value": "65", "--size": "12rem", "--thickness": "2px" }}>
                            <span className='text-2xl'>NodeJs</span>
                        </div>
                    </div>
                    <div data-aos="flip-right" data-aos-easing="ease-out-cubic" className='text-center col-span-4 sm:col-span-2 lg:col-span-1 space-y-10'>
                        <div className="radial-progress color-font" style={{ "--value": "80", "--size": "12rem", "--thickness": "2px" }}>
                            <span className='text-2xl'>Next Js</span>
                        </div>
                    </div>

                    <div data-aos="flip-left" data-aos-easing="ease-out-cubic" className='text-center col-span-4 sm:col-span-2 lg:col-span-1 space-y-10'>
                        <div className="radial-progress color-font" style={{ "--value": "90", "--size": "12rem", "--thickness": "2px" }}>
                            <span className='text-2xl'>Redux</span>
                        </div>
                    </div>
                    <div data-aos="flip-right" data-aos-easing="ease-out-cubic" className='text-center col-span-4 sm:col-span-2 lg:col-span-1 space-y-10'>
                        <div className="radial-progress color-font" style={{ "--value": "50", "--size": "12rem", "--thickness": "2px" }}>
                            <span className='text-2xl'>Metarial UI</span>
                        </div>
                    </div>
                    <div data-aos="flip-left" data-aos-easing="ease-out-cubic" className='text-center col-span-4 sm:col-span-2 lg:col-span-1 space-y-10'>
                        <div className="radial-progress color-font" style={{ "--value": "90", "--size": "12rem", "--thickness": "2px" }}>
                            <span className='text-2xl'>Tailwind CSS</span>
                        </div>
                    </div>
                    <div data-aos="flip-right" data-aos-easing="ease-out-cubic" className='text-center col-span-4 sm:col-span-2 lg:col-span-1 space-y-10'>
                        <div className="radial-progress color-font" style={{ "--value": "80", "--size": "12rem", "--thickness": "2px" }}>
                            <span className='text-2xl'>Bootstrap</span>
                        </div>
                    </div>

                </div>


            </div>

            <div className="w-3/5 h-1 bg-gradient-to-l from-neutral-content absolute right-0 z-50"></div>


        </div>
    );
};

export default Skills;